import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'icon-envelope',
  templateUrl: './envelope.component.html',
  styleUrls: ['./envelope.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvelopeComponent {}
